import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useOnboardingStore } from '@features/onboarding/store/onboarding';
import { useAuthStore } from 'src/store/auth';

import { W2_TID } from '../constants/testids';
import { useW2Mode } from '../store/w2-mode';
import { w2Paths } from '../flow/paths';
import { SELECTION_LOGIN_REDIRECT } from '../selection/routes';

/**
 * Always-visible W2 header action. The B2C menu is too coupled to B2C profile
 * state and always redirects to `/login`, so this thin W2 control reuses the
 * same auth-store logout action while choosing the correct employee login:
 * tokenized PHQ → that token's `/login`; selection → W2-host `/login?next=…`.
 */
export const W2HeaderLogout: React.FC = () => {
  const navigate = useNavigate();
  const logout = useAuthStore((state) => state.logout);
  const employerToken = useW2Mode((state) => state.token);

  const handleLogout = () => {
    // Match the existing B2C HeaderMenu cleanup before ending the shared JWT
    // session. This prevents one employee's in-memory PHQ answers surviving an
    // SPA navigation to another employee's login.
    useOnboardingStore.getState().resetData();
    logout();
    navigate(
      employerToken ? w2Paths(employerToken).login : SELECTION_LOGIN_REDIRECT,
      { replace: true }
    );
  };

  return (
    <button
      type="button"
      data-testid={W2_TID.header.logout}
      onClick={handleLogout}
      className="text-primary hover:bg-gray-100 focus-visible:ring-primary relative z-30 rounded-lg px-4 py-2 text-sm font-semibold text-nowrap focus-visible:ring-2 focus-visible:outline-none"
    >
      Logout
    </button>
  );
};
